import React from 'react'
import ReactDomServer from 'react-dom/server'

export const base64EncodeSvg = (svg: React.ReactElement): string => {
  const svgString = ReactDomServer.renderToString(svg)
  const base64Svg =
    typeof window === 'undefined'
      ? Buffer.from(svgString).toString('base64')
      : window.btoa(svgString)
  return `data:image/svg+xml;base64,${base64Svg}`
}
